var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReservoir(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2L18 6H17V12.25H18C18.4142 12.25 18.75 12.5858 18.75 13C18.75 13.4142 18.4142 13.75 18 13.75H16.935L18.6016 21.25H22C22.4142 21.25 22.75 21.5858 22.75 22C22.75 22.4142 22.4142 22.75 22 22.75H2C1.58579 22.75 1.25 22.4142 1.25 22C1.25 21.5858 1.58579 21.25 2 21.25H5.39837L7.06504 13.75H6C5.58579 13.75 5.25 13.4142 5.25 13C5.25 12.5858 5.58579 12.25 6 12.25H7V6H6L12 2ZM12 15.591L14.0455 13.75H9.95447L12 15.591ZM10.8789 16.6L8.45339 14.4171L7.24065 19.8744L10.8789 16.6ZM12 17.609L7.95447 21.25H16.0455L12 17.609ZM16.7593 19.8744L15.5466 14.4171L13.1211 16.6L16.7593 19.8744ZM13.6 9.83333C13.6 9.14647 12.7091 8.18543 12.2569 7.74187C12.1128 7.60058 11.8872 7.60058 11.7431 7.74187C11.2909 8.18543 10.4 9.14647 10.4 9.83333C10.4 10.7538 11.1164 11.5 12 11.5C12.8837 11.5 13.6 10.7538 13.6 9.83333Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReservoir);
export default __webpack_public_path__ + "static/media/reservoir.b2cfb475ec483b028e2dcddcc280dd43.svg";
export { ForwardRef as ReactComponent };